import { ApolloClient, InMemoryCache } from "@apollo/client";
import fetch from "isomorphic-fetch";

const client = new ApolloClient({
  uri: process.env.GATSBY_PATSTORE_GRAPHQL_API_URL as string,
  // fetchOptions: {
  // 	mode: 'no-cors'
  // },
  headers: {
    "X-Parse-Application-Id": process.env.GATSBY_PATSTORE_APP_ID as string,
    "X-Parse-Rest-Api-Key": process.env.GATSBY_PATSTORE_REST_KEY as string,
  },
  connectToDevTools: true,
  cache: new InMemoryCache(),
  fetch,
});

export default client;
